// extracted by mini-css-extract-plugin
module.exports = {"photoPost":"UserPhotoPost_photoPost__2HOgp","file":"UserPhotoPost_file__2u_ou","preview":"UserPhotoPost_preview__202Fl","modal":"UserPhotoPost_modal__rRPEz"};